import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";
import type { AgentToolStatus } from "../../../../api/copilotAgentTypes";
import { toolDisplayNames } from "../copilotAgentsHelpers";

interface Props {
  tools: AgentToolStatus[];
}

const ToolsSection = ({ tools }: Props) => {
  const [open, setOpen] = useState(false);
  const enabledCount = tools.filter((t) => t.enabled).length;
  const hasDisabled = enabledCount < tools.length;

  return (
    <Box>
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
        <ExpandCollapseButton
          expanded={open}
          onToggle={() => setOpen((v) => !v)}
          ExpandIcon={ExpandIcon}
          CollapseIcon={CollapseIcon}
        />
        <Typography>
          Tools ({enabledCount}/{tools.length} active)
          {hasDisabled && <WarningRoundedIcon color="warning" sx={{ ml: 0.5, verticalAlign: "text-bottom" }} />}
        </Typography>
      </Stack>
      <Collapse in={open}>
        <Box sx={{ mt: 0.5, pl: 1.5 }}>
          {tools.map((t) => (
            <Stack key={t.name} direction="row" spacing={1} sx={{ alignItems: "baseline", py: 0.25 }}>
              <Typography variant="caption" sx={{ color: t.enabled ? "success.main" : "text.disabled", width: 12 }}>
                {t.enabled ? "✓" : "✗"}
              </Typography>
              <Typography
                variant="caption"
                sx={{ fontWeight: "medium", color: t.enabled ? "text.primary" : "text.disabled", minWidth: 110 }}
              >
                {toolDisplayNames[t.name] ?? t.name}
              </Typography>
              <Typography variant="caption" color={t.enabled ? "textSecondary" : "textDisabled"}>
                {t.enabled ? t.description : t.disabledReason}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default ToolsSection;
